import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import { ProductCardRedesignTestData, UseProductCardRedesign } from "./types";

const CUSTOM_RULE_ID = "productCardRedesignTest";

const useProductCardRedesign: UseProductCardRedesign = () => {
  const { isLoading, value } = useMonarchRule<{
    data: ProductCardRedesignTestData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
      data: {
        showRedesign: false,
      },
    };
  }

  const variant = value?.data?.showRedesign ? "test" : "control";

  return {
    isLoading,
    variant,
    data: value?.data,
  };
};

export default useProductCardRedesign;
